/* Footie Elite — minimal vanilla JS */
(function(){
  // sticky nav glass + condense on scroll
  var siteHeader = document.querySelector('[data-site-header]');
  var nav = document.querySelector('.nav');
  if (nav){
    var onScroll = function(){
      var y = window.scrollY;
      nav.classList.toggle('scrolled', y > 30);
      if (siteHeader){ siteHeader.classList.toggle('is-condensed', y > 160); }
    };
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }

  // branded desktop cursor
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (finePointer && finePointer.matches && !(window.Shopify && window.Shopify.designMode)){
    var cursor = document.createElement('div');
    var cursorX = 0;
    var cursorY = 0;
    var targetX = 0;
    var targetY = 0;
    var hasPointer = false;
    var cursorFrame = null;
    var interactiveSelector = 'a, button, label, summary, [role="button"], .product-card, .program, .why-item, .loc, .product-thumb';
    var textSelector = 'input:not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="submit"]), textarea, select, [contenteditable="true"]';

    cursor.className = 'brand-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = [
      '<svg class="brand-cursor__arrow" viewBox="0 0 34 34" focusable="false">',
        '<path class="brand-cursor__shadow" d="M6 4 28 16.5 18.2 18.8 14.4 28 6 4Z"></path>',
        '<path class="brand-cursor__outline" d="M6 4 28 16.5 18.2 18.8 14.4 28 6 4Z"></path>',
      '</svg>'
    ].join('');
    document.body.appendChild(cursor);
    document.body.classList.add('has-brand-cursor');

    var drawCursor = function(){
      cursorX += (targetX - cursorX) * 0.28;
      cursorY += (targetY - cursorY) * 0.28;
      cursor.style.setProperty('--cursor-x', cursorX + 'px');
      cursor.style.setProperty('--cursor-y', cursorY + 'px');
      cursorFrame = window.requestAnimationFrame(drawCursor);
    };

    var setCursorTarget = function(event){
      if (event.pointerType && event.pointerType !== 'mouse'){ return; }

      targetX = event.clientX;
      targetY = event.clientY;

      if (!hasPointer){
        hasPointer = true;
        cursorX = targetX;
        cursorY = targetY;
        cursor.classList.add('is-visible');
        if (!cursorFrame){ drawCursor(); }
      }

      var target = event.target;
      var overText = target && target.closest && target.closest(textSelector);
      var overInteractive = target && target.closest && target.closest(interactiveSelector);
      cursor.classList.toggle('is-over-text', !!overText);
      cursor.classList.toggle('is-hovering', !!overInteractive && !overText);
    };

    document.addEventListener('pointermove', setCursorTarget, { passive:true });
    document.addEventListener('pointerenter', function(){
      if (hasPointer){ cursor.classList.add('is-visible'); }
    });
    document.addEventListener('pointerleave', function(){
      cursor.classList.remove('is-visible');
    });
    document.addEventListener('pointerdown', function(event){
      if (!event.pointerType || event.pointerType === 'mouse'){
        cursor.classList.add('is-pressing');
      }
    });
    document.addEventListener('pointerup', function(){
      cursor.classList.remove('is-pressing');
    });
  }

  // search overlay (mobile/tablet)
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchOverlayInput = document.querySelector('[data-search-overlay-input]');
  var setSearchOpen = function(open){
    if (!searchOverlay){ return; }
    searchOverlay.hidden = !open;
    document.querySelectorAll('[data-search-toggle]').forEach(function(btn){
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open && searchOverlayInput){
      window.requestAnimationFrame(function(){ searchOverlayInput.focus(); });
    }
  };
  document.querySelectorAll('[data-search-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      setSearchOpen(searchOverlay && searchOverlay.hidden);
    });
  });

  // keyboard shortcut: "/" focuses header search (or opens overlay if hidden)
  document.addEventListener('keydown', function(event){
    if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey){ return; }
    var target = event.target;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)){ return; }
    var deskInput = document.querySelector('[data-header-search] input');
    if (deskInput && deskInput.offsetParent !== null){
      event.preventDefault();
      deskInput.focus();
    } else if (searchOverlay){
      event.preventDefault();
      setSearchOpen(true);
    }
  });

  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileOpen = document.querySelector('[data-mobile-menu-open]');
  var mobileClose = document.querySelector('[data-mobile-menu-close]');

  var setMobileMenuOpen = function(open){
    if (!mobileMenu){ return; }
    document.body.classList.toggle('mobile-menu-open', open);
    mobileMenu.hidden = !open;
    if (mobileOpen){
      mobileOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  if (mobileOpen){
    mobileOpen.setAttribute('aria-expanded', 'false');
    mobileOpen.addEventListener('click', function(){
      setMobileMenuOpen(true);
    });
  }

  if (mobileClose){
    mobileClose.addEventListener('click', function(){
      setMobileMenuOpen(false);
    });
  }

  if (mobileMenu){
    mobileMenu.addEventListener('click', function(event){
      if (event.target === mobileMenu || event.target.tagName === 'A'){
        setMobileMenuOpen(false);
      }
    });
  }

  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('.cart-overlay');
  var cartItems = document.querySelector('[data-cart-items]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');
  var cartCounts = document.querySelectorAll('[data-cart-count]');
  var cartInlineSubtotals = document.querySelectorAll('[data-cart-subtotal-inline]');
  var cartOpenTriggers = document.querySelectorAll('[data-cart-open]');

  var formatMoney = function(cents){
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency
    }).format((Number(cents) || 0) / 100);
  };

  var escapeHTML = function(value){
    return String(value || '').replace(/[&<>"']/g, function(character){
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  };

  var setCartOpen = function(open){
    if (!cartDrawer){ return; }
    document.body.classList.toggle('cart-open', open);
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (cartOverlay){ cartOverlay.hidden = !open; }
  };

  var syncCartUpsells = function(cart){
    var productIds = {};
    var hasItems = cart && cart.items && cart.items.length > 0;

    if (hasItems){
      cart.items.forEach(function(item){
        productIds[String(item.product_id)] = true;
      });
    }

    document.querySelectorAll('[data-cart-upsells]').forEach(function(group){
      var hasVisibleUpsells = false;
      group.querySelectorAll('[data-cart-upsell]').forEach(function(card){
        var hide = !hasItems || !!productIds[String(card.getAttribute('data-product-id'))];
        card.hidden = hide;
        if (!hide){ hasVisibleUpsells = true; }
      });
      group.hidden = !hasVisibleUpsells;
    });
  };

  var renderCart = function(cart){
    var hasItems = cart.item_count > 0;

    cartCounts.forEach(function(count){
      count.textContent = cart.item_count;
      count.hidden = !hasItems;
    });

    cartOpenTriggers.forEach(function(trigger){
      trigger.setAttribute('aria-label', hasItems ? 'Cart with ' + cart.item_count + ' items' : 'Bag empty');
    });

    if (cartSubtotal){
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    cartInlineSubtotals.forEach(function(el){
      el.textContent = hasItems ? formatMoney(cart.total_price) : 'Empty';
    });

    if (!cartItems){ return; }

    if (!cart.items || cart.items.length === 0){
      cartItems.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
      syncCartUpsells(cart);
      return;
    }

    cartItems.innerHTML = cart.items.map(function(item, index){
      var title = escapeHTML(item.product_title);
      var variant = escapeHTML(item.variant_title);
      var image = item.image ? '<img src="' + item.image + '" alt="' + title + '">' : '<div class="cart-line__placeholder"></div>';
      return [
        '<div class="cart-line" data-line="' + (index + 1) + '">',
          image,
          '<div>',
            '<a class="cart-line__title" href="' + item.url + '">' + title + '</a>',
            item.variant_title ? '<span class="cart-line__variant">' + variant + '</span>' : '',
            '<div class="cart-line__controls">',
              '<span class="cart-line__stepper">',
                '<button type="button" data-line-minus aria-label="Decrease quantity of ' + title + '">−</button>',
                '<b data-line-qty>' + item.quantity + '</b>',
                '<button type="button" data-line-plus aria-label="Increase quantity of ' + title + '">+</button>',
              '</span>',
              '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>',
            '</div>',
          '</div>',
          '<b>' + formatMoney(item.final_line_price) + '</b>',
        '</div>'
      ].join('');
    }).join('');

    syncCartUpsells(cart);
  };

  var cartBusy = false;
  var changeCartLine = function(line, quantity){
    if (cartBusy){ return; }
    cartBusy = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function(response){ return response.json(); })
      .then(renderCart)
      .catch(function(){ refreshCart(); })
      .finally(function(){ cartBusy = false; });
  };

  if (cartItems){
    cartItems.addEventListener('click', function(event){
      var lineEl = event.target.closest('[data-line]');
      if (!lineEl){ return; }
      var line = Number(lineEl.getAttribute('data-line'));
      if (event.target.closest('[data-line-remove]')){ changeCartLine(line, 0); return; }
      var qtyEl = lineEl.querySelector('[data-line-qty]');
      var qty = qtyEl ? Number(qtyEl.textContent) || 1 : 1;
      if (event.target.closest('[data-line-minus]')){ changeCartLine(line, Math.max(0, qty - 1)); }
      else if (event.target.closest('[data-line-plus]')){ changeCartLine(line, qty + 1); }
    });
  }

  document.addEventListener('click', function(event){
    var upsellButton = event.target.closest('[data-cart-upsell-add]');
    if (!upsellButton || upsellButton.disabled || !window.fetch){ return; }

    var variantId = Number(upsellButton.getAttribute('data-variant-id'));
    if (!variantId){ return; }

    event.preventDefault();
    upsellButton.disabled = true;
    upsellButton.textContent = 'Adding';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(response){
        if (!response.ok){ throw new Error('Cart upsell add failed'); }
        return response.json();
      })
      .then(function(){
        var pageUpsell = upsellButton.closest('[data-cart-upsell-context="page"]');
        if (pageUpsell){
          window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
          return null;
        }

        return refreshCart().then(function(){ setCartOpen(true); });
      })
      .catch(function(){
        upsellButton.disabled = false;
        upsellButton.textContent = 'Add';
      });
  });

  var refreshCart = function(){
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response){ return response.json(); })
      .then(function(cart){
        renderCart(cart);
        return cart;
      });
  };

  cartOpenTriggers.forEach(function(trigger){
    trigger.addEventListener('click', function(event){
      if (!cartDrawer){ return; }
      event.preventDefault();
      refreshCart().then(function(){ setCartOpen(true); });
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function(trigger){
    trigger.addEventListener('click', function(event){
      event.preventDefault();
      setCartOpen(false);
    });
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape'){
      setCartOpen(false);
      setMobileMenuOpen(false);
      setSearchOpen(false);
    }
  });

  document.addEventListener('submit', function(event){
    var form = event.target.closest('[data-product-form], [data-quick-add-form]');
    if (!form || !window.fetch){ return; }

    var submitter = event.submitter;
    if (form.hasAttribute('data-product-form') && submitter && !submitter.hasAttribute('data-add-to-cart')){
      return;
    }

    event.preventDefault();

    if (submitter){
      submitter.disabled = true;
      submitter.classList.add('is-loading');
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function(response){
        if (!response.ok){ throw new Error('Cart add failed'); }
        return response.json();
      })
      .then(function(){
        return refreshCart();
      })
      .then(function(){
        setCartOpen(true);
      })
      .catch(function(){
        form.submit();
      })
      .finally(function(){
        if (submitter){
          submitter.disabled = false;
          submitter.classList.remove('is-loading');
        }
      });
  });

  // product waitlist -> Klaviyo list + Shopify customer tags
  var KLAVIYO_COMPANY_ID = 'WSFvzL';
  var KLAVIYO_PRODUCT_WAITLIST_LIST_ID = 'VCEmkn';
  var KLAVIYO_REVISION = '2026-04-15';

  var normalizeWaitlistPropertyKey = function(handle){
    var key = String(handle || 'product').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    return key || 'product';
  };

  var normalizeWaitlistPhone = function(value){
    var raw = String(value || '').trim();
    if (!raw){ return ''; }

    var digits = raw.replace(/\D/g, '');
    if (raw.charAt(0) === '+' && digits.length >= 10){
      return '+' + digits;
    }

    if (digits.length === 10){
      return '+1' + digits;
    }

    if (digits.length === 11 && digits.charAt(0) === '1'){
      return '+' + digits;
    }

    return '';
  };

  var subscribeProductWaitlistToKlaviyo = function(details){
    if (!window.fetch || !details.email){ return Promise.resolve(); }

    var now = new Date().toISOString();
    var propertyKey = 'fe_waitlist_' + normalizeWaitlistPropertyKey(details.handle);
    var properties = {
      fe_product_waitlist: true,
      fe_product_waitlist_latest_product: details.title,
      fe_product_waitlist_latest_handle: details.handle,
      fe_product_waitlist_source: 'shopify_product_page',
      fe_product_waitlist_at: now
    };
    properties[propertyKey] = true;
    properties.fe_product_waitlist_phone_provided = !!details.phone;
    properties.fe_product_waitlist_sms_opt_in = !!details.smsOptIn;
    if (details.smsOptIn){
      properties[propertyKey + '_sms_opt_in'] = true;
    }

    var profileAttributes = {
      email: details.email,
      properties: properties
    };

    if (details.phone){
      profileAttributes.phone_number = details.phone;
    }

    if (details.smsOptIn && details.phone){
      profileAttributes.subscriptions = {
        email: { marketing: { consent: 'SUBSCRIBED' } },
        sms: { marketing: { consent: 'SUBSCRIBED' } }
      };
    }

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footie Elite product waitlist - ' + (details.title || 'Product'),
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_PRODUCT_WAITLIST_LIST_ID } }
          }
        }
      })
    }).then(function(response){
      if (!response.ok && response.status !== 202){
        throw new Error('Klaviyo waitlist failed');
      }
    });
  };

  document.addEventListener('submit', function(event){
    var form = event.target.closest('[data-product-waitlist]');
    if (!form || form.hasAttribute('data-waitlist-submitting')){ return; }

    var emailInput = form.querySelector('input[type="email"]');
    var phoneInput = form.querySelector('[data-waitlist-phone]');
    var smsOptInInput = form.querySelector('[data-waitlist-sms-opt-in]');
    var email = emailInput ? String(emailInput.value || '').trim().toLowerCase() : '';
    var phone = normalizeWaitlistPhone(phoneInput ? phoneInput.value : '');
    var smsOptIn = !!(smsOptInInput && smsOptInInput.checked);
    if (!email || !window.fetch){ return; }

    if (phoneInput){
      phoneInput.setCustomValidity('');
    }

    if (smsOptIn && !phone){
      event.preventDefault();
      if (phoneInput){
        phoneInput.setCustomValidity('Enter a valid phone number.');
        phoneInput.reportValidity();
      }
      return;
    }

    event.preventDefault();
    form.setAttribute('data-waitlist-submitting', 'true');

    var submitter = event.submitter || form.querySelector('button[type="submit"]');
    if (submitter){
      submitter.disabled = true;
      submitter.classList.add('is-loading');
    }

    subscribeProductWaitlistToKlaviyo({
      email: email,
      phone: phone,
      smsOptIn: smsOptIn,
      title: form.getAttribute('data-product-title') || '',
      handle: form.getAttribute('data-product-handle') || ''
    }).catch(function(){
      // Shopify's native customer form still captures the signup if Klaviyo is unavailable.
    }).finally(function(){
      form.submit();
    });
  });

  // location list <-> map sync
  document.querySelectorAll('[data-loc-list]').forEach(function(list){
    var locs = list.querySelectorAll('.loc');
    locs.forEach(function(loc){
      loc.addEventListener('click', function(){
        locs.forEach(function(l){ l.classList.remove('active'); });
        loc.classList.add('active');
      });
    });
  });

  // product gallery
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-thumb]'));
    var frames = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-frame]'));
    var stage = gallery.querySelector('.product-gallery__stage');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var activeIndex = Math.max(0, frames.findIndex(function(frame){
      return frame.classList.contains('is-active');
    }));

    var setActiveMedia = function(id){
      if (!id){ return; }
      var matched = false;

      frames.forEach(function(frame, index){
        var isMatch = frame.getAttribute('data-media-frame') === id;
        frame.classList.toggle('is-active', isMatch);
        if (isMatch){ activeIndex = index; }
        matched = matched || isMatch;
      });

      if (!matched){ return; }

      thumbs.forEach(function(thumb){
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-thumb') === id);
      });
    };

    var setActiveIndex = function(index){
      if (!frames.length){ return; }
      var nextIndex = (index + frames.length) % frames.length;
      setActiveMedia(frames[nextIndex].getAttribute('data-media-frame'));
    };

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        setActiveMedia(thumb.getAttribute('data-media-thumb'));
      });
    });

    if (prev){
      prev.addEventListener('click', function(){
        setActiveIndex(activeIndex - 1);
      });
    }

    if (next){
      next.addEventListener('click', function(){
        setActiveIndex(activeIndex + 1);
      });
    }

    if (stage && frames.length > 1){
      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerActive = false;

      stage.addEventListener('pointerdown', function(event){
        if (event.target.closest('button')){ return; }
        pointerActive = true;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      stage.addEventListener('pointerup', function(event){
        if (!pointerActive){ return; }
        pointerActive = false;
        var deltaX = event.clientX - pointerStartX;
        var deltaY = event.clientY - pointerStartY;
        if (Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY)){ return; }
        setActiveIndex(activeIndex + (deltaX < 0 ? 1 : -1));
      });

      stage.addEventListener('pointercancel', function(){
        pointerActive = false;
      });
    }

    gallery.setActiveMedia = setActiveMedia;
  });

  // variant selection + product buy controls
  document.querySelectorAll('[data-product-root]').forEach(function(root){
    var variantsScript = root.querySelector('[data-product-variants]');
    var form = root.querySelector('[data-product-form]');
    if (!variantsScript || !form){ return; }

    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var idInput = form.querySelector('[data-variant-id]');
    var optionInputs = form.querySelectorAll('[data-option-input]');
    var price = root.querySelector('[data-product-price]');
    var comparePrice = root.querySelector('[data-product-compare-price]');
    var salePill = root.querySelector('[data-product-sale-pill]');
    var addButton = form.querySelector('[data-add-to-cart]');
    var addButtonText = form.querySelector('[data-add-to-cart-text]');
    var dynamicCheckout = root.querySelector('.product-dynamic-checkout');
    var gallery = root.querySelector('[data-product-gallery]');
    var stock = root.querySelector('[data-product-stock]');
    var stockText = root.querySelector('[data-product-stock-text]');

    var selectedOptions = function(){
      var options = [];
      optionInputs.forEach(function(input){
        if (input.checked){
          options[Number(input.getAttribute('data-option-position')) - 1] = input.value;
        }
      });
      return options;
    };

    var findVariant = function(){
      var options = selectedOptions();
      return variants.find(function(variant){
        return variant.options.every(function(value, index){
          return value === options[index];
        });
      });
    };

    var syncVariant = function(){
      var variant = findVariant();
      if (!variant){ return; }

      if (idInput){ idInput.value = variant.id; }
      if (price){ price.textContent = variant.price; }

      if (comparePrice){
        comparePrice.textContent = variant.compare_at_price || '';
        comparePrice.classList.toggle('is-hidden', !variant.compare_at_price);
      }

      if (salePill){
        salePill.classList.toggle('is-hidden', !variant.compare_at_price);
      }

      if (addButton){
        addButton.disabled = !variant.available;
      }

      if (addButtonText){
        addButtonText.textContent = variant.available ? (addButton.getAttribute('data-add-text') || 'Add to cart') : 'Sold out';
      }

      if (dynamicCheckout){
        dynamicCheckout.hidden = !variant.available;
      }

      if (gallery && gallery.setActiveMedia && variant.featured_media_id){
        gallery.setActiveMedia(String(variant.featured_media_id));
      }

      if (stock){
        stock.classList.toggle('is-sold-out', !variant.available);
      }

      if (stockText && stock){
        stockText.textContent = variant.available ? stock.getAttribute('data-in-stock-text') : stock.getAttribute('data-sold-out-text');
      }

      if (window.history && window.history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    optionInputs.forEach(function(input){
      input.addEventListener('change', syncVariant);
    });

    syncVariant();
  });

  // quantity steppers
  document.querySelectorAll('[data-quantity]').forEach(function(stepper){
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-quantity-minus]');
    var plus = stepper.querySelector('[data-quantity-plus]');
    if (!input){ return; }

    var clamp = function(value){
      var min = Number(input.getAttribute('min')) || 1;
      return Math.max(min, value);
    };

    if (minus){
      minus.addEventListener('click', function(){
        input.value = clamp((Number(input.value) || 1) - 1);
      });
    }

    if (plus){
      plus.addEventListener('click', function(){
        input.value = clamp((Number(input.value) || 1) + 1);
      });
    }
  });
})();
